(function() {
    'use strict';

    angular
        .module('bluebookApp')
        .controller('IncidentTypeDialogController', IncidentTypeDialogController);

    IncidentTypeDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'IncidentType', 'CoreService'];

    function IncidentTypeDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, IncidentType, CoreService) {
        var vm = this;

        vm.incidentType = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.incidentType.id !== null) {
                IncidentType.update(vm.incidentType, onSaveSuccess, onSaveError);
            } else {
                IncidentType.save(vm.incidentType, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('bluebookApp:incidentTypeUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
